import * as types from '../mutation-types';

// Which agents have which conversations open, keyed by conversation display
// id. The server sends the whole map on every change and the client replaces
// it, so there is nothing to merge and a stale snapshot heals on the next one.
const state = {
  records: {},
};

export const getters = {
  // Resolved to the shape the avatar stack wants, minus yourself and minus
  // anyone the agents store does not know about yet.
  getViewers: ($state, _getters, _rootState, rootGetters) => conversationId => {
    const ids = $state.records[conversationId] || [];
    const currentUserId = rootGetters.getCurrentUserID;
    return ids
      .map(Number)
      .filter(id => id !== currentUserId)
      .map(id => rootGetters['agents/getAgentById'](id))
      .filter(agent => agent && agent.id)
      .map(({ id, name, thumbnail }) => ({ id, name, thumbnail }));
  },
};

export const actions = {
  set: ({ commit }, viewers) => {
    commit(types.default.SET_CONVERSATION_VIEWERS, viewers);
  },
};

export const mutations = {
  [types.default.SET_CONVERSATION_VIEWERS]: ($state, viewers) => {
    $state.records = viewers || {};
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
